module.exports = __webpack_public_path__ + "media/images/favicon-32x32-330c88e5a46f5fd64cb72d845b9b6126.png";